import { WebEDIRowData } from 'support/types/webediTable';

// The width of `SsccLabelActions`, for the column width resolver.
// An extra-small button with a left icon: `px-2.5`, the border and the icon with its margin, plus 1px for rounding.
const BUTTON_CHROME_PX = 45;
const BUTTON_GAP_PX = 8;
// `size-5`
const SPINNER_PX = 20;

export const ssccLabelActionsWidth =
  (labels: Array<string>) => (measureText: (text: string) => number, rows: Array<unknown>) => {
    const units = rows as Array<WebEDIRowData>;
    if (units.some((row) => (row.transport_label as { pdf_url?: string } | undefined)?.pdf_url)) {
      return (
        labels.reduce((sum, label) => sum + measureText(label) + BUTTON_CHROME_PX, 0) +
        BUTTON_GAP_PX * (labels.length - 1)
      );
    }
    // A unit without a label shows a spinner while the message is in progress.
    return units.some((row) => row.unit_identifier) ? SPINNER_PX : 0;
  };
